import CustomAxiosInstance from "../middlewares/axios/connectionErrorMiddleware";
import { destinationEndpoints } from "../helpers/requests/apiEndpoints";
import { formatSerbiaTime } from "../config/dayjsConfig";

const api = CustomAxiosInstance();

const methods = {
  getDestinations: () =>
    api.get(destinationEndpoints.getDestinationsUrl).then((res) => res.data),
  getDestinationsByDate: (payload) =>
    api
      .get(
        destinationEndpoints.getDestinationsByDateUrl.replace(
          "{date}",
          formatSerbiaTime(payload)
        )
      )
      .then((res) => res.data),
  createDestination: (payload) =>
    api
      .post(destinationEndpoints.createDestinationUrl, payload)
      .then((res) => res.data),
};

export default methods;
